<template>
  <div
    class="h-align-center home-subscribe"
    :class="$style['home-subscribe']">
    <div class="container container--tiny container--inline">
      <h2>{{ $t('partials/newsletter-already-receiving') }}</h2>
      <hr :class="$style['gold']">
      <p v-html="$t('partials/newsletter-every-week-updates')" />
      <form
        v-if="!done"
        :class="$style['home-subscribe__form']"
        @submit.prevent="subscribe">
        <FormInput
          v-show="!toggle"
          v-model="nameInput"
          data-test-id="home-subscribe-name-input"
          :class="$style['form-input']"
          :placeholder="$t('partials/newsletter-your-name')" />
        <FormInput
          v-show="toggle"
          ref="email"
          v-model="emailInput"
          data-test-id="home-subscribe-email-input"
          type="email"
          :class="$style['form-input']"
          :placeholder="$t('partials/newsletter-your-emailaddress')" />
        <Btn
          type="submit"
          color="cta"
          data-test-id="home-subscribe-submit"
          icon-only="System/arrow-right-s-line"
          aria-label="Go" />
      </form>
      <div
        v-else
        data-test-id="home-subscribe-message"
        class="h-margin-top">
        <h2>{{ $t('general/yes-you-are-awesome') }}</h2>
      </div>
      <div v-if="errors.length" class="h-margin-top">
        <NotificationGroup>
          <Notification v-for="error in errors" :key="error.id" type="error">
            {{ error.message }}
          </Notification>
        </NotificationGroup>
      </div>
    </div>
  </div>
</template>
<script setup>
const { $api } = useNuxtApp()
const done = ref(false)
const email = ref(null)
const nameInput = ref(null)
const emailInput = ref(null)
const toggle = ref(false)
const errors = ref([])

const subscribe = async () => {
  errors.value = []
  if (nameInput.value) {
    toggle.value = true
    nextTick(() => {
      if (!email.value) { return }
      email.value.$el.querySelector('input').focus()
    })
  }
  if (!nameInput.value || !emailInput.value) { return }
  const data = new FormData()
  if (nameInput.value) {
    data.append('name', nameInput.value)
  }
  if (emailInput.value) {
    data.append('email', emailInput.value)
  }

  try {
    const response = await $api('newsletter', { method: 'POST', body: data })
    if (response.status === 'Success') {
      done.value = true
    }
  } catch (e) {
    errors.value = e.response._data.errors
  }
}
</script>

<style lang="scss" module>
.home-subscribe {
  background-color: var(--grey-lighter);
  width: 100%;

  &__form {
    align-items: center;
    display: grid;
    grid-template-columns: auto 100px;
    grid-gap: var(--spacing);

    @media (max-width: #{$breakpoint-mobile}) {
      grid-template-columns: auto 80px;
    }
  }
}

.gold {
  border-top: 8px solid var(--gold);
  width: calc(var(--spacing) * 8);
  margin: calc(var(--spacing) * 3) auto;
}
</style>
